export const calculatePoints = answer => {
    return 0;
}